import get from 'lodash/fp/get.js';

const wasUpdatedAtLeastAsRecentlyAs = (entity1, entity2) =>
  new Date(get('updatedAt', entity1)) >= new Date(get('updatedAt', entity2));

export default wasUpdatedAtLeastAsRecentlyAs;
